import { rankWith, uiTypeIs } from "@jsonforms/core"

export const UAccordionContainerTester = rankWith(
  1000,
  uiTypeIs("AccordionGroup"),
)
